<template>
  <LiveStreamingRoom />
</template>

<script>
import LiveStreamingRoom from './LiveStreamingRoom.vue';

export default {
  name: 'BreakoutRoom',
  components: {
    LiveStreamingRoom,
  },
};
</script>